import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

interface ActiveGroup {
  slug: string;
  name: string;
  activeRoom: {
    roomCode: string;
    status: string;
    playerCount: number;
  };
}

interface ActiveGroupBannerProps {
  onJoinGroup: (slug: string, playerName: string) => void;
}

export function ActiveGroupBanner({ onJoinGroup }: ActiveGroupBannerProps) {
  const { user } = useAuth();
  const [groups, setGroups] = useState<ActiveGroup[]>([]);

  useEffect(() => {
    if (!user) return;
    const token = localStorage.getItem('flip7_access_token');
    if (!token) return;
    const apiBase = import.meta.env.VITE_API_URL || '';
    fetch(`${apiBase}/api/groups/active`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => (res.ok ? res.json() : []))
      .then(setGroups)
      .catch(() => {});
  }, [user?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  if (groups.length === 0) return null;

  return (
    <div className="group-banner">
      {groups.map((g) => (
        <button
          key={g.slug}
          className="surface--raised group-banner__item"
          onClick={() => onJoinGroup(g.slug, user?.name ?? '')}
        >
          <span className="group-banner__dot" />
          <div className="group-banner__info">
            <div className="group-banner__name">{g.name} is playing</div>
            <div className="group-banner__status">
              {g.activeRoom.playerCount} player{g.activeRoom.playerCount !== 1 ? 's' : ''}
              {g.activeRoom.status === 'playing' && ' · In game'}
              {g.activeRoom.status === 'waiting' && ' · In lobby'}
            </div>
          </div>
          <span className="group-banner__join">JOIN</span>
        </button>
      ))}
    </div>
  );
}
